import templateUrl from './tax-notice-assigned-list.component.html';

export const TaxNoticeAssignedListComponent = {
    templateUrl,
    controller: TaxNoticeAssignedListController,
    controllerAs: "vm",
};

function TaxNoticeAssignedListController(taxNoticeService, employeeService,
    utilityService, teamService, taxNoticeUpdateService) {
    'ngInject';
    const vm = this;
    vm.EmailAddress;
    vm.isComment = false;
    vm.comment = comment;
    vm.saveComment = saveComment;
    vm.toggle = toggle;
    vm.documents = [];
    vm.documentsbk = [];
    vm.allComments = [];

    vm.cancel = cancel;
    vm.unassign = unassign;

    vm.onSelectCommentFile = onSelectCommentFile;
    vm.noticeCommentFiles;
    vm.commentFileName;
    vm.downloadNoticeCommentDoc = downloadNoticeCommentDoc;
    vm.isStatusHistory = false;
    vm.statusHistory = statusHistory;
    vm.allStatuses = [];
    vm.close = close;

    vm.filters;
    vm.onChangeFilters = onChangeFilters;

    vm.editID = '';
    vm.editDesc = '';
    vm.setEditNotice = setEditNotice;
    vm.clearEditNotice = clearEditNotice;

    vm.$onInit = function () {
        utilityService.showLoading();
        taxNoticeUpdateService.taxNoticeRefreshEvents$.forEach(event => {
            if (event === "update") {
                refreshData();
            }
        });

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.EmailAddress = result.UserName;
                taxNoticeService.retrieveAssignedDocuments(result.UserName)
                    .then(function (docs) {
                        vm.documents = docs;
                        vm.documentsbk = docs;
                        utilityService.hideLoading();
                        return docs;
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
            })
    };

    function setEditNotice(noticeDocumentId: string, description: string) {
        vm.editID = noticeDocumentId;
        vm.editDesc = description;
    }

    function clearEditNotice() {
        vm.editID = '';
        vm.editDesc = '';
    }
    function toggle(document: any, description: string) {
        if (document.Description !== description) {
            utilityService.showLoading();
            taxNoticeService.updateDescription({
                TaxNoticeDocumentId: document.NoticeDocumentId,
                Text: description
            }).then(function (result) {
                vm.editID = '';
                vm.editDesc = '';
                const edited = vm.documents.find(x => x.NoticeDocumentId === document.NoticeDocumentId);
                edited.Description = description;
                vm.documents.splice(vm.documents.indexOf(document), 1, edited);
                utilityService.hideLoading();
            }).catch(function (ex) {
                utilityService.hideLoading();
            });
        } else {
            vm.editID = '';
            vm.editDesc = '';
        }
    }
    function close() {
        vm.isUpload = false;
        vm.showAssign = false;
        vm.isStatusHistory = false;
        vm.isComment = false;
    }

    function refreshData() {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.EmailAddress = result.UserName;
                taxNoticeService.retrieveAssignedDocuments(vm.EmailAddress)
                    .then(function (docs) {
                        vm.documents = docs;
                        vm.documentsbk = docs;
                        utilityService.hideLoading();
                        return docs;
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
            })
    }

    function cancel() {
        if (confirm('Are you sure to Cancel?') === true) {
            vm.isComment = false;
            vm.isStatusHistory = false;
            vm.commentText = '';
            vm.commentFileName = '';
            vm.noticeCommentFiles = '';
        }
    }

    function comment(taxNoticeDocumentId: any, fileName: any, currentStatus: any) {
        utilityService.showLoading();
        vm.isComment = true;
        vm.taxNoticeDocumentId = taxNoticeDocumentId;
        vm.fileName = fileName;
        vm.currentStatus = currentStatus;
        console.log(vm.currentStatus);

        taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
            .then(function (result) {
                vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
            })
    }

    function onSelectCommentFile() {
        vm.commentFileName = vm.noticeCommentFiles.name;
    }

    function downloadNoticeCommentDoc(commentId: any) {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((identity) => {
                taxNoticeService.downloadNoticeCommentDocument({
                    CommentId: commentId,
                    TaxNoticeDocumentId: 'N/A',
                    UserName: identity.UserName,
                    Text: 'downloading comment file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                })
                    .then(function (isDownloaded) {
                        utilityService.hideLoading();
                        return isDownloaded;
                    })
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Downloading failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function saveComment() {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((identity) => {
                vm.userName = identity.UserName;
                taxNoticeService.saveComment({
                    TaxNoticeDocumentId: vm.taxNoticeDocumentId,
                    UserName: identity.UserName,
                    Text: vm.commentText,
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember',
                    Files: vm.noticeCommentFiles
                })
                    .then(function (isSaved) {
                        if (isSaved === true) {
                            taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
                                .then(function (comments) {
                                    vm.commentText = null;
                                    vm.commentFileName = null;
                                    vm.noticeCommentFiles = undefined;
                                    vm.allComments[0] = comments;
                                    utilityService.hideLoading();
                                })
                        }
                        return isSaved;
                    })
                return identity;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Saving failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function statusHistory(requestId: any) {
        utilityService.showLoading();
        vm.isStatusHistory = true;
        vm.requestId = requestId;

        taxNoticeService.retrieveStatusHistory(vm.requestId)
            .then(function (result) {
                vm.allStatuses[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("StatusHistory: " + utilityService.getExceptionMessage(err));
            })
    }

    function unassign(noticeDocumentId: any) {
        utilityService.showLoading();

        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((id) => {
                taxNoticeService.unAssignDocument({
                    TaxNoticeDocumentId: noticeDocumentId,
                    UserName: 'UserName',
                    Text: 'Text',
                    TeamId: 'TeamId',
                    TeamMemberEmpId: 'TeamMemberId',
                })
                    .then(function (isUnassign) {
                        utilityService.hideLoading();
                        taxNoticeUpdateService.refreshTaxNotice('update');
                        return isUnassign;
                    })
                return id;
            })
            .catch((err) => {
                utilityService.hideLoading();
            })
    }

    function onChangeFilters() {
        vm.filterDocs = vm.documentsbk;
        if (vm.filters.clientName) {
            vm.filterDocs = vm.filterDocs.filter(x => x.CompanyName.toLowerCase()
                .includes(vm.filters.clientName.toLowerCase()));
        }
        if (vm.filters.owner) {
            vm.filterDocs = vm.filterDocs.filter(x => x.OwnerName.toLowerCase()
                .includes(vm.filters.owner.toLowerCase()));
        }
        if (vm.filters.noticeNumber) {
            vm.filterDocs = vm.filterDocs.filter(x => String(x.RequestNumber) === String(vm.filters.noticeNumber));
        }
        if (vm.filters.uploadFrom) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) >= vm.filters.uploadFrom);
        }
        if (vm.filters.uploadTo) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) <= vm.filters.uploadTo);
        }
        vm.documents = vm.filterDocs;
        console.log(vm.filterDocs);
    }
}
